import { useAppSelector } from "@src/reduxStore";
import { FC } from "react";
import { useIntl } from "react-intl";

export interface LinkToReportServiceProps {
  countryCode?: string;
  orgBusinessId?: string;
}

const LinkToReportService: FC<LinkToReportServiceProps> = ({
  countryCode,
  orgBusinessId,
  children,
}) => {
  const config = useAppSelector(state => state.common.config);
  const intl = useIntl();

  return (
    <a
      href={intl.formatMessage(
        {
          id: "reportServiceUrl",
          defaultMessage: "{bolUrl}/#/search/{countryCode}%2F{orgBusinessId}",
        },
        {
          bolUrl: config?.bolUrl,
          countryCode,
          orgBusinessId,
        }
      )}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  );
};

export default LinkToReportService;
